import { render } from "./ExploreMarketPlace.vue?vue&type=template&id=bb391740"
import script from "./ExploreMarketPlace.vue?vue&type=script&lang=js"
export * from "./ExploreMarketPlace.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__